/**
 * Split what a lead typed into invoice numbers.
 *
 * The field is free text on purpose. A delivery arrives on up to ten
 * invoices and the numbers come off a delivery note by hand or out of a
 * spreadsheet column by paste, so they turn up separated by newlines,
 * commas, semicolons or tabs depending on where they came from. Making
 * someone tidy that up before the form accepts it is work the machine
 * can do.
 *
 * This only splits. Normalising — case, whitespace, duplicates — is the
 * server's, so that a number typed here and a number arriving from
 * anywhere else end up in exactly one form. Doing it in both places
 * means two rules that drift apart, and the symptom would be a join
 * against the invoice sheet that fails for some jobs and not others.
 */
export function splitInvoices(raw: string): string[] {
  return raw
    .split(/[\n\r,;\t]+/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}
